import React, { useEffect, useRef, useState  } from "react";
import { useLocation } from "react-router-dom";
import { BrowserRouter as Router, Routes, Route, Link } from "react-router-dom";
import './styles/Styles.css';
import Home from "./pages/Home";
import Menu from "./pages/Menu";
import About from "./pages/About";
import Gallery from "./pages/Gallery";
import Contact from "./pages/Contact";
import Header from "./components/Header";
import Showcase from "./components/Showcase";
import Footer from "./components/Footer";
import ScrollToTopButton from "./components/ScrollToTopButton";
import FormSuccess from "./pages/FormSuccess";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import NotFound from "./pages/NotFound";
import './styles/FadeIn.css';
import './styles/ScrollToTopButton.css';

function App() {

  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    setIsVisible(true);
  }, []);

  const location = useLocation();
  
  useEffect(() => {
    switch(location.pathname) {
      case "/":
        document.title = "Restauracja Andrychów | Sami Swoi - Tradycyjna Polska Kuchnia"
        break;
      case "/menu":
        document.title = "Tradycyjne Polskie Potrawy w Andrychowie | Sami Swoi"
        break;
      case "/o-nas":
        document.title = "Poznaj naszą restaurację w Andrychowie | Sami Swoi"
        break;
      case "/galeria":
        document.title = "Wystrój gotowy na Twoją imprezę okolicznościową | Sami Swoi"
        break;
      case "/kontakt":
        document.title = "Zarezerwuj lokal na swoją imprezę lub zadaj pytanie"
        break;
      case "/formsuccess":
        document.title = "Twoja wiadomość została wysłana, odpowiemy tak szybko, jak to możliwe!"
        break;
      case "/polityka":
        document.title = "Polityka Prywatności dla wysyłanych wiadomości | Restauracja Sami Swoi"
        break;
    }
  }, [location.pathname]);

  const dishSectionRef = useRef(null);

  const scrollToDishSection = () => {
    if (dishSectionRef.current) {
      dishSectionRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }

  return (
    <div>
      <ScrollToTopButton />
      <div className={`fade-in-container ${isVisible ? 'visible' : ''}`}>
        <Header onScrollToDishSection={scrollToDishSection} />
        <Showcase />
        <Routes>
          <Route path="/" element={<Home dishSectionRef={dishSectionRef} />} />
          <Route path="/menu" element={<Menu onScrollToDishSection={scrollToDishSection} />} />
          <Route path="/o-nas" element={<About />} />
          <Route path="/galeria" element={<Gallery />} />
          <Route path="/kontakt" element={<Contact />} />
          <Route path="/wyslano" element={<FormSuccess />} />
          <Route path="/polityka" element={<PrivacyPolicy />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </div>
  );

}

export default App;
